'use client';
import * as React from 'react';

var ThemeContext = React.createContext({});
var Consumer = ThemeContext.Consumer, Provider = ThemeContext.Provider;
function ThemeProvider(props) {
    return (React.createElement(Provider, { value: { theme: props.theme } }, props.children));
}

export { Consumer as ThemeConsumer, ThemeContext, ThemeProvider };
